import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Directions.svg",
  "use": "Directions.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Directions.svg\"><path d=\"M57.1034,34.1286,34.1089,57.1231a3,3,0,0,1-4.242,0L6.8721,34.1286a3,3,0,0,1,0-4.2418L29.8669,6.8919a2.9994,2.9994,0,0,1,4.242,0L57.1037,29.8868A3,3,0,0,1,57.1034,34.1286Zm-11.5374-6.92-9.948-6.9887A1.0245,1.0245,0,0,0,34,21.0384v4.9825H30.01a8,8,0,0,0-8,8v8a2,2,0,0,0,4,0v-8a4,4,0,0,1,4-4H34V35.016a1.0245,1.0245,0,0,0,1.6183.819l9.948-6.9887A.9969.9969,0,0,0,45.566,27.2081Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol